import {
  ResponsiveContainer,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  BarChart,
  Bar,
  LabelList,
  Cell,
} from "recharts";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "../CustomLegend";
import { Button, Modal } from "react-bootstrap";
import CustomTooltip from "../CustomTooltip";
import CustomTooltipCat from "../CustomTooltipCat";
import api from "../../../api";

const StaticCategory = ({ data }) => {
  const [showTable, setShowTable] = useState(false);
  const [selectedYear, setSelectedYear] = useState(2023);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [showDistrictModal, setShowDistrictModal] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState({
    state: "",
    category: "",
  });
  useEffect(() => {
    fetchCategoryData();
  }, [selectedYear]);
  console.log("cat", data);
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const fetchCategoryData = async () => {
    try {
      setLoading(true);

      const res = await api.get("/static-data-count", {
        params: {
          Year: selectedYear,
        },
      });

      setApiData(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = data.filter(
    (item) => Number(item.year) === Number(selectedYear),
  );
  let catData = [];
  let tableData = [];

  // State-level → show counts for each severity
  catData = apiData
    .map((item) => ({
      place: item.Place,
      VeryLow: item.VeryLow,
      Low: item.Low,
      Moderate: item.Moderate,
      High: item.High,
    }))
    .sort((a, b) => a.place.localeCompare(b.place));

  tableData = apiData
    .map((item) => ({
      place: item.Place,
      VeryLow: item.VeryLow,
      Low: item.Low,
      Moderate: item.Moderate,
      High: item.High,
    }))
    .sort((a, b) => a.place.localeCompare(b.place));

  const handleBarClick = async (data, category) => {
    try {
      const state = data.place;

      console.log("Clicked:", { state, category });

      // 🔥 API call
      const res = await api.get("/static-data", {
        params: {
          State: state,
          Year: selectedYear,
          category: category,
          // StartMonth: 2026,
          // EndMonth: 2026,
        },
      });
      console.log("Response:", res.data);
      setDistricts(res.data);
      setShowDistrictModal(true);
      setSelectedInfo({
        state,
        category,
      });
    } catch (err) {
      console.error(err);
      // toast.error("Failed to fetch district data");
    }
  };

  return (
    <>
      <div style={{ width: "100%", position: "relative" }}>
        <div className="card hptCard mt-4 border-0">
          <div class="card-header brBtomlr">
            <div class="headnumText justify-content-between">
              <div class="cardTitle d-flex align-items-center gap-3">
                <h5>Category of Districts</h5>
                <Form.Select
                  size="sm"
                  style={{ width: "120px" }}
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  <option value={2023}>2023</option>
                  <option value={2025}>2025</option>
                </Form.Select>
              </div>

              <div class="cardDropDown">
                <span style={{ marginRight: "10px", fontWeight: 500 }}>
                  {showTable ? "Chart View" : "Table View"}
                </span>
                <Form>
                  <Form.Check
                    type="switch"
                    id="chart-table-toggle"
                    onChange={() => setShowTable((prev) => !prev)}
                    checked={showTable}
                  />
                </Form>
              </div>
            </div>
          </div>
        </div>
        {showTable ? (
          // ---------- Table View ----------
          <div className="card hptCard mt-4 border-0">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th className="fw-bold">States</th>

                    <th className="text-center fw-bold ">Very Low</th>
                    <th className="text-center fw-bold"> Low</th>
                    <th className="text-center fw-bold">Moderate</th>
                    <th className="text-center fw-bold">High</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((item, idx) => (
                    <tr key={idx}>
                      <td className="fw-bold">{item.place}</td>

                      <td>{item.VeryLow}</td>
                      <td>{item.Low}</td>
                      <td>{item.Moderate}</td>
                      <td>{item.High}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          // ---------- Chart View ----------
          <div>
            <div className="card hptCard mt-4 border-0">
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={400}
                  data={catData.slice(0, 15)}
                  margin={{
                    top: 20,
                    right: 30,
                    left: 40,
                    bottom: 250,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                    label={{
                      value: "",
                      position: "insideBottom",
                      offset: -110,
                      color: "#ca8282ff",
                      fontWeight: "bold",
                    }}
                  />
                  <YAxis />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={
                      <CustomLegend
                        order={["Very Low", "Low", "Moderate", "High"]}
                      />
                    }
                  />
                  <Bar
                    dataKey="VeryLow"
                    fill="#00a084"
                    name="Very Low"
                    onClick={(data) => handleBarClick(data, "VeryLow")}
                  >
                    <LabelList dataKey="VeryLow" position="top" />
                  </Bar>
                  <Bar
                    dataKey="Low"
                    fill="#608ce6ff"
                    name="Low"
                    onClick={(data) => handleBarClick(data, "Low")}
                  >
                    <LabelList dataKey="Low" position="top" />
                  </Bar>
                  <Bar
                    dataKey="Moderate"
                    fill="#ffc40c"
                    name="Moderate"
                    onClick={(data) => handleBarClick(data, "Moderate")}
                  >
                    <LabelList dataKey="Moderate" position="top" />
                  </Bar>
                  <Bar
                    dataKey="High"
                    fill="#dd1e47"
                    name="High"
                    onClick={(data) => handleBarClick(data, "High")}
                  >
                    <LabelList dataKey="High" position="top" />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            {catData.length > 15 && (
              <div className="card hptCard mt-4 border-0">
                <ResponsiveContainer width="100%" height={600}>
                  <BarChart
                    width={500}
                    height={400}
                    data={catData.slice(15)}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 40,
                      bottom: 180,
                    }}
                  >
                    <XAxis
                      dataKey="place"
                      angle={-90}
                      textAnchor="end"
                      interval={0}
                      label={{
                        value: "",
                        position: "insideBottom",
                        offset: -110,
                        color: "#ca8282ff",
                        fontWeight: "bold",
                      }}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                      verticalAlign="top"
                      content={
                        <CustomLegend
                          order={["Very Low", "Low", "Moderate", "High"]}
                        />
                      }
                    />
                    <Bar
                      dataKey="VeryLow"
                      fill="#00a084"
                      name="Very Low"
                      onClick={(data) => handleBarClick(data, "VeryLow")}
                    >
                      <LabelList dataKey="VeryLow" position="top" />
                    </Bar>
                    <Bar
                      dataKey="Low"
                      fill="#608ce6ff"
                      name="Low"
                      onClick={(data) => handleBarClick(data, "Low")}
                    >
                      <LabelList dataKey="Low" position="top" />
                    </Bar>
                    <Bar
                      dataKey="Moderate"
                      fill="#ffc40c"
                      name="Moderate"
                      onClick={(data) => handleBarClick(data, "Moderate")}
                    >
                      <LabelList dataKey="Moderate" position="top" />
                    </Bar>
                    <Bar
                      dataKey="High"
                      fill="#dd1e47"
                      name="High"
                      onClick={(data) => handleBarClick(data, "High")}
                    >
                      <LabelList dataKey="High" position="top" />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            )}
          </div>
        )}
      </div>
      <Modal
        show={showDistrictModal}
        onHide={() => setShowDistrictModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            {selectedInfo.state} - {selectedInfo.category}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {districts.length === 0 ? (
            <p>No data found</p>
          ) : (
            <div>
              {/* Summary */}
              <div style={{ marginBottom: "10px" }}>
                <strong>Total Districts: {districts.length}</strong>
              </div>

              {/* Horizontal Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 200px)", // fixed width columns
                  justifyContent: "center", // 👈 centers whole grid
                  gap: "12px",
                }}
              >
                {districts.map((d, i) => (
                  <div
                    key={i}
                    style={{
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      background: "#f9f9f9",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {d.district}
                  </div>
                ))}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowDistrictModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StaticCategory;
